"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOOLTIP_CATEGORY_KEY = 'base';
exports.TOOLTIP_COMPONENT_KEY = 'tooltip';